import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'What’s it like to work at Kredit Pintar?',
    title1: `"What i love working in here, that the mindset in across the team is very open. We can discuss and brainstorm in any kind of project"`,
    title2: `"Working environment is very warm, plus snacks, tea, or coffee are always ready to boost you up"`,
    title3: `"Togetherner, lots of fun and cool employee events, that is i think a factor that keep us closed and support each other"`,
    desc1: '- Shan, Marketing Team',
    desc2: '- Novi, HR Team',
    desc3: '- Yoga, Finance Team',
  },
  id: {
    title: 'Bagaimana kesan bekerja di Kredit Pintar?',
    title1: `"Apa yang saya suka dari bekerja di Kredit Pintar adalah, pola pikir antar team sangat terbuka. Kita bisa lakukan diskusi atau pendalaman akan project-project yang sedang kita jalankan"`,
    title2: `"Lingkungan kerja nya hangat, ditambah cemilan, teh, kopi, selalu ada untuk buat kamu tetap semangat"`,
    title3: `"Kebersamaan, banyaknya kegiatan karyawan yang penuh keseruan, itu menurut saya faktor yang membuat kita dekat dan saling dukung satu sama lain"`,
    desc1: '- Shan, Marketing Team',
    desc2: '- Novi, HR Team',
    desc3: '- Yoga, Finance Team',
  },
})

const HowToWork = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const BenefitsList = [
    {
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      title: t('title3'),
      desc: t('desc3'),
    },
  ]
  return (
    <Whys>
      <div className="title">{t('title')}</div>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {BenefitsList.map((item, index) => (
          <div key={index} className="item">
            <div className="subtitle">{item.title}</div>
            <div className="desc">{item.desc}</div>
          </div>
        ))}
      </div>
    </Whys>
  )
}

export default HowToWork

const Whys = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 40px auto;
    text-align: center;
    width: 100%;
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      width: 90%;
      margin: 64px auto 0;
    }
    .items {
      .item {
        margin: 48px auto 0;
        min-height: 376px;
        width: 288px;
        text-align: left;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        line-height: 32px;
        .subtitle {
          padding-top: 20px;
          color: #9e9e9e;
        }
        .desc {
          padding-top: 28px;
          color: #1cc812;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 16px 150px 50px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 60px auto;
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 40px;
      padding-bottom: 44px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        width: 360px;
        text-align: left;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        line-height: 32px;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        .subtitle {
          flex: 1;
          padding-top: 28px;
          color: #212121;
          max-width: 300px;
          min-height: 200px;
        }
        .desc {
          color: #1cc812;
        }
      }
    }
  }
`
